<h1>Verpackungsgruppe</h1>
<pre *ngIf="item">{{ item | json }}</pre>
<form [formGroup]="form">
  <mat-form-field>
    <mat-label> Name</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>
</form>
<button mat-button mat-raised-button (click)="clickSave()">Speichern</button>
